 import axios from "axios";

const SearchHistory = {
    namespaced: true,
    state: {
        history: null,

        // /** for pagination*/
        // totalRecord: null,
        // previousUrl: null,
        // nextUrl: null,
    },
    mutations: {
        setHistory: function (state, payload) {
            state.history = payload;
        },
        // setTotalRecord: function (state, payload) {
        //     state.totalRecord = payload;
        // },
        // setPreviousUrl: function (state, payload) {
        //     state.previousUrl = payload;
        // },
        // setNextUrl: function (state, payload) {
        //     state.nextUrl = payload;
        // }
    },
    actions: {
        getHistory: async function (state, payload) {

            var baseUrl = `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/history`;
            var paginationUrl = payload.url;
            if (paginationUrl != null) {
                baseUrl = payload.url;
            }

            var config = {
                method: 'post',
                url: baseUrl,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('_khonsu_app_token')}`
                },
                data : JSON.stringify(payload)
            };

            return  axios(config);

        }
    },
    getters: {

    },
}
export default SearchHistory